"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _formik = require("formik");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _Input = _interopRequireDefault(require("../../../ui/Input"));
var _Label = _interopRequireDefault(require("../../../ui/Label"));
var _CurrencyControl = _interopRequireDefault(require("./components/CurrencyControl"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var extractNumber = function extractNumber(number) {
  return R.replace(/[^0-9]/g, '', number);
};
var PriceControl = function PriceControl() {
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Label.default, {
    clickable: false,
    text: t('PRICE_CONTROL_LABEL')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.priceRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.inputs
  }, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _fn.QUERY_PARAMS.PRICE,
    render: function render(_ref) {
      var field = _ref.field,
        form = _ref.form;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Input.default, {
        className: _styles.default.input,
        placeholder: t('PRICE_FROM_CONTROL_LABEL'),
        value: field.value.from || '',
        onChange: function onChange(from) {
          return form.setFieldValue(field.name, R.mergeAll([field.value, {
            from: extractNumber(from)
          }]));
        }
      }), /*#__PURE__*/_react.default.createElement(_Input.default, {
        className: _styles.default.input,
        placeholder: t('PRICE_TO_CONTROL_LABEL'),
        value: field.value.to || '',
        onChange: function onChange(to) {
          return form.setFieldValue(field.name, R.mergeAll([field.value, {
            to: extractNumber(to)
          }]));
        }
      }));
    }
  })), /*#__PURE__*/_react.default.createElement(_CurrencyControl.default, null)));
};
var _default = exports.default = (0, _react.memo)(PriceControl);